import { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { injectIntl } from 'react-intl';
import { toastr } from 'react-redux-toastr';
import styles from './CreateTreatmentModal.module.scss';
import Modal from '../Shared/Modal/Modal';
import { Button } from '../Shared/Buttons';
import { InputItem, InputRow, InputGroup, InputSubGroup } from '..//Shared/Forms/';
import { AlertBox } from '../Shared/Alerts';
import * as patientActions from '../../redux/actions/patientActions';
import * as referenceDataActions from '../../redux/actions/referenceDataActions';
import * as studyGroupActions from '../../redux/slices/studyGroupSlice';
import { toastrOptions } from '../../constants/toastrOptions';

class CreateTreatmentModal extends Component {
  constructor(props) {
    super(props);

    this.state = {
      comment: '',
      loadingProtocol: 'NoSelection',
      plannedProstheticSolution: 'NoSelection',
      surgicalProtocol: 'NoSelection',
      insertionTorque: -1,
      studyGroups: [],
      prePlacementProcedure: 'NoSelection',
      boneQuality: '',
      implantSitePlacement: 'NoSelection',
      augmentationMaterial: 'NoSelection',
      surgicalTechnique: 'NoSelection',
    };

    this.intl = props.intl;

    this.createImplant = false;

    this.hideCreateImplantModal = this.hideCreateImplantModal.bind(this);
    this.saveImplant = this.saveImplant.bind(this);
    this.loadingProtocolChanged = this.loadingProtocolChanged.bind(this);
    this.plannedProstheticSolutionChanged = this.plannedProstheticSolutionChanged.bind(this);
    this.surgicalProtocolChanged = this.surgicalProtocolChanged.bind(this);
    this.commentChanged = this.commentChanged.bind(this);
    this.insertionTorqueChanged = this.insertionTorqueChanged.bind(this);
    this.prePlacementSelected = this.prePlacementSelected.bind(this);
    this.boneQualitySelected = this.boneQualitySelected.bind(this);
    this.implantSitePlacementSelected = this.implantSitePlacementSelected.bind(this);
    this.augmentationMaterialSelected = this.augmentationMaterialSelected.bind(this);
    this.surgicalTechniqueSelected = this.surgicalTechniqueSelected.bind(this);

    this.prePlacementProcedures = props.prePlacementProcedures.map((x) => ({
      key: x.key,
      value: this.intl.formatMessage({ ...x.label }),
    }));

    this.boneQualityOptions = [{ value: '1' }, { value: '2' }, { value: '3' }, { value: '4' }];
    this.implantSitePlacementOptions = props.implantSitePlacementOptions.map((x) => ({
      key: x.key,
      value: this.intl.formatMessage({ ...x.label }),
    }));

    this.augmentationMaterialOptions = props.augmentationMaterialOptions.map((x) => ({
      key: x.key,
      value: this.intl.formatMessage({ ...x.label }),
    }));

    this.surgicalTechniqueOptions = props.surgicalTechniqueOptions.map((x) => ({
      key: x.key,
      value: this.intl.formatMessage({ ...x.label }),
    }));
  }

  componentDidMount() {
    this.props.actions.getStudyGroups();
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    if (nextProps.show && nextProps.implant && !this.props.show) {
      this.setState({
        comment: nextProps.implant.comment,
        loadingProtocol: nextProps.implant.loadingProtocol,
        plannedProstheticSolution: nextProps.implant.plannedProstheticSolution,
        surgicalProtocol: nextProps.implant.surgicalProtocol,
        insertionTorque: nextProps.implant.insertionTorque,
        prePlacementProcedure: nextProps.implant.prePlacementProcedure,
        boneQuality: nextProps.implant.boneQuality?.toString(),
        implantSitePlacement: nextProps.implant.implantSitePlacement,
        augmentationMaterial: nextProps.implant.augmentationMaterial,
        surgicalTechnique: nextProps.implant.surgicalTechnique,
        studyGroups: nextProps.implant.studyGroups,
      });
    }

    if (nextProps.createImplant.complete && this.createImplant) {
      this.setState({
        showSaveMenu: false,
      });
      this.createImplant = false;
      toastr.success(
        this.intl.formatMessage({ id: 'general.success', defaultMessage: 'Success' }),
        this.intl.formatMessage({ id: 'implant.implantSaved', defaultMessage: 'Implant saved' }),
        toastrOptions
      );
      this.hideCreateImplantModal();
    }
  }

  hideCreateImplantModal() {
    this.setState(
      {
        comment: '',
        loadingProtocol: 'NoSelection',
        plannedProstheticSolution: 'NoSelection',
        surgicalProtocol: 'NoSelection',
        insertionTorque: -1,
        studyGroups: [],
        prePlacementProcedure: 'NoSelection',
        boneQuality: '',
        implantSitePlacement: 'NoSelection',
        augmentationMaterial: 'NoSelection',
        surgicalTechnique: 'NoSelection',
      },
      () => {
        if (this.props.hide) {
          this.props.hide();
        }
      }
    );
  }

  saveImplant() {
    if (this.props.selectedImplant <= 0) return;

    this.createImplant = true;
    this.props.actions.createImplant(
      this.props.patient.sourceUserGroupId,
      this.props.patient.id,
      this.props.selectedImplant,
      this.state.comment,
      this.state.loadingProtocol,
      this.state.plannedProstheticSolution,
      this.state.surgicalProtocol,
      this.state.insertionTorque,
      this.state.prePlacementProcedure,
      this.state.boneQuality,
      this.state.implantSitePlacement,
      this.state.augmentationMaterial,
      this.state.surgicalTechnique,
      this.state.studyGroups
    );
  }

  loadingProtocolChanged(evt) {
    this.setState({
      loadingProtocol: evt.target.value,
      surgicalProtocol: evt.target.value === 'ConventionalLoading' ? 'TwoStage' : 'OneStage',
    });
  }

  plannedProstheticSolutionChanged(evt) {
    this.setState({
      plannedProstheticSolution: evt.target.value,
    });
  }

  surgicalProtocolChanged(evt) {
    this.setState({
      surgicalProtocol: evt.target.value,
    });
  }

  insertionTorqueChanged(evt) {
    let value = evt.target.value;
    if (value.length === 0) value = -1;

    if (Number(value)) {
      this.setState({
        insertionTorque: value,
      });
    }
  }

  commentChanged(evt) {
    this.setState({
      comment: evt.target.value,
    });
  }

  prePlacementSelected(evt) {
    this.setState({
      prePlacementProcedure: evt.target.value,
    });
  }
  boneQualitySelected(evt) {
    this.setState({
      boneQuality: evt.target.value,
    });
  }
  implantSitePlacementSelected(evt) {
    this.setState({
      implantSitePlacement: evt.target.value,
    });
  }
  augmentationMaterialSelected(evt) {
    this.setState({
      augmentationMaterial: evt.target.value,
    });
  }
  surgicalTechniqueSelected(evt) {
    this.setState({
      surgicalTechnique: evt.target.value,
    });
  }

  studyGroupClick(id) {
    let studyGroups = [...this.state.studyGroups];
    const index = studyGroups.findIndex((x) => x.id === id);
    if (index === -1) studyGroups.push({ id: id, included: true });
    else studyGroups[index] = { ...studyGroups[index], included: !studyGroups[index].included };

    this.setState({
      studyGroups: studyGroups,
    });
  }

  renderStudyGroups() {
    if (this.props.studyGroups && this.props.studyGroups.length > 0)
      return (
        <InputSubGroup
          label={this.intl.formatMessage({
            id: 'implant.studyGroups',
            defaultMessage: 'Study Groups',
          })}
          className={styles.studyGroups}
        >
          {this.props.studyGroups
            .filter((group) =>
              group.members.some((x) => x.userId === this.props.user.id && !x.pending)
            )
            .map((group) => {
              return (
                <InputRow key={group.id}>
                  <div>
                    <InputItem
                      type="checkbox"
                      label={group.name}
                      checked={this.state.studyGroups.some((x) => x.id === group.id && x.included)}
                      onChange={this.studyGroupClick.bind(this, group.id)}
                      noMargins
                      noMarginBottom
                      className={styles.studyCheckBox}
                    />
                  </div>
                </InputRow>
              );
            })}
        </InputSubGroup>
      );
  }

  getToothName(tooth) {
    const notification = this.props.dentalNotifications.find((item) => item.uns === tooth);
    if (notification) {
      const { name, uns, fdi } = notification;
      const capitalized = name.charAt(0).toUpperCase() + name.slice(1);
      const toothNumber = this.props.user.teethNotation === 'UNS' ? uns : fdi;
      return toothNumber + '. ' + capitalized;
    }
    return '';
  }

  render() {
    const error = this.props.createImplant.error;

    return (
      <div>
        <Modal
          header={
            `${this.getToothName(this.props.selectedImplant)} - ` +
            this.intl.formatMessage({ id: 'implant.addTreatment', defaultMessage: 'Add treatment' })
          }
          onDismiss={this.hideCreateImplantModal}
          show={this.props.show}
        >
          <div className={styles.content}>
            {error ? (
              <AlertBox
                color="black"
                headerText="Oops, there was an error"
                messages={error.messages.map((m) => m.text)}
              />
            ) : null}
            <div className={styles.column}>
              <InputGroup
                label={this.intl.formatMessage({
                  id: 'implant.treatmentOverview',
                  defaultMessage: 'Treatment overview',
                })}
              >
                <InputRow>
                  <InputItem
                    dataCy="create-treatment-modal-additional-procedures"
                    label={this.intl.formatMessage({
                      id: 'implant.additionalProcedures',
                      defaultMessage: 'Additional surgical procedures',
                    })}
                    type="select"
                    options={this.prePlacementProcedures}
                    defaultKey={'NoSelection'}
                    defaultValue={''}
                    value={this.state.prePlacementProcedure}
                    onChange={this.prePlacementSelected}
                    onWhite
                  />
                </InputRow>
                <InputRow>
                  <InputItem
                    dataCy="create-treatment-modal-planned-prosthetic"
                    label={this.intl.formatMessage({
                      id: 'implant.plannedProstheticSolution',
                      defaultMessage: 'Planned Prosthetic Solution',
                    })}
                    type="selectbutton"
                    options={this.props.plannedProstheticSolutions.map((x) => ({
                      key: x.key,
                      value: this.intl.formatMessage({ ...x.label }),
                    }))}
                    value={this.state.plannedProstheticSolution}
                    onChange={this.plannedProstheticSolutionChanged}
                    centered
                    onWhite
                    span
                  />
                </InputRow>
                <InputRow>
                  <InputItem
                    dataCy="create-treatment-modal-loading-protocol"
                    label={this.intl.formatMessage({
                      id: 'implant.loadingProtocol',
                      defaultMessage: 'Loading Protocol',
                    })}
                    type="selectbutton"
                    options={this.props.loadingProtocols.map((x) => ({
                      key: x.key,
                      value: this.intl.formatMessage({ ...x.label }),
                    }))}
                    value={this.state.loadingProtocol}
                    onChange={this.loadingProtocolChanged}
                    centered
                    onWhite
                    span
                  />
                </InputRow>
                <InputRow>
                  <InputItem
                    dataCy="create-treatment-modal-surgical-protocol"
                    label={this.intl.formatMessage({
                      id: 'implant.surgicalProtocol',
                      defaultMessage: 'Surgical Protocol',
                    })}
                    type="selectbutton"
                    options={this.props.surgicalProtocols.map((x) => ({
                      key: x.key,
                      value: this.intl.formatMessage({ ...x.label }),
                    }))}
                    value={this.state.surgicalProtocol}
                    onChange={this.surgicalProtocolChanged}
                    centered
                    onWhite
                    span
                  />
                </InputRow>
                {/* <InputRow>
                  <InputItem
                    label={this.intl.formatMessage({ id: 'Maximum Insertion Torque (Ncm)' })}
                    type="text"
                    value={this.state.insertionTorque > 0 ? this.state.insertionTorque : ''}
                    onChange={this.insertionTorqueChanged}
                    onWhite
                  />
                </InputRow> */}
                {this.renderStudyGroups()}
              </InputGroup>
            </div>
            <div className={styles.column}>
              <InputGroup
                label={this.intl.formatMessage({
                  id: 'implant.siteAndTreatment',
                  defaultMessage: 'Implant site and treatment',
                })}
              >
                <InputRow>
                  <InputItem
                    dataCy="create-treatment-modal-bone-quality"
                    label={this.intl.formatMessage({
                      id: 'implant.boneQuality',
                      defaultMessage: 'Bone quality',
                    })}
                    type="selectbutton"
                    options={this.boneQualityOptions}
                    centered
                    onWhite
                    value={this.state.boneQuality}
                    onChange={this.boneQualitySelected}
                    span
                  />
                </InputRow>
                <InputRow>
                  <InputItem
                    dataCy="create-treatment-modal-implant-site"
                    label={this.intl.formatMessage({
                      id: 'implant.implantSitePlacement',
                      defaultMessage: 'Implant site - Placement',
                    })}
                    type="select"
                    options={this.implantSitePlacementOptions}
                    defaultKey={'NoSelection'}
                    defaultValue={''}
                    onWhite
                    value={this.state.implantSitePlacement}
                    onChange={this.implantSitePlacementSelected}
                  />
                </InputRow>
                {this.state.implantSitePlacement === 'HealedBoneGraft' ||
                this.state.implantSitePlacement === 'ExtractionPlacementBoneGraft' ? (
                  <InputRow>
                    <InputItem
                      dataCy="create-treatment-modal-augmentation-material"
                      label={this.intl.formatMessage({
                        id: 'implant.augmentationMaterial',
                        defaultMessage: 'Augmentation Material',
                      })}
                      type="select"
                      options={this.augmentationMaterialOptions}
                      defaultKey={'NoSelection'}
                      defaultValue={''}
                      onWhite
                      value={this.state.augmentationMaterial}
                      onChange={this.augmentationMaterialSelected}
                    />
                  </InputRow>
                ) : null}
                {this.state.implantSitePlacement === 'ExtractionPlacement' ||
                this.state.implantSitePlacement === 'ExtractionPlacementBoneGraft' ? (
                  <InputRow>
                    <InputItem
                      label={this.intl.formatMessage({
                        id: 'implant.surgicalTechnique',
                        defaultMessage: 'Surgical Technique',
                      })}
                      type="select"
                      options={this.surgicalTechniqueOptions}
                      defaultKey={'NoSelection'}
                      defaultValue={''}
                      onWhite
                      value={this.state.surgicalTechnique}
                      onChange={this.surgicalTechniqueSelected}
                    />
                  </InputRow>
                ) : null}
                <InputRow>
                  <InputItem
                    dataCy="create-treatment-modal-comment"
                    label={this.intl.formatMessage({
                      id: 'general.comment',
                      defaultMessage: 'Comment',
                    })}
                    type="textarea"
                    value={this.state.comment}
                    onChange={this.commentChanged}
                    onWhite
                  />
                </InputRow>
              </InputGroup>
            </div>
          </div>
          <div className={styles.buttons}>
            <Button
              value={this.intl.formatMessage({ id: 'general.cancel', defaultMessage: 'Cancel' })}
              onClick={() => this.hideCreateImplantModal()}
            />
            <Button
              dataCy="create-treatment-modal-save-button"
              primary
              value={this.intl.formatMessage({ id: 'general.save', defaultMessage: 'Save' })}
              onClick={this.saveImplant}
              disabled={this.createImplant}
              loading={this.createImplant}
            />
          </div>
        </Modal>
      </div>
    );
  }
}

function mapState(state) {
  return {
    user: state.user.user,
    createImplant: state.patient.createImplant,
    patient: state.patient.currentPatient,
    selectedImplant: state.patient.selectedPatientImplant,
    loadingProtocols: state.referenceData.loadingProtocols,
    plannedProstheticSolutions: state.referenceData.plannedProstheticSolutions,
    surgicalProtocols: state.referenceData.surgicalProtocols,
    prePlacementProcedures: state.referenceData.prePlacementProcedures,
    implantSitePlacementOptions: state.referenceData.implantSitePlacementOptions,
    augmentationMaterialOptions: state.referenceData.augmentationMaterialOptions,
    surgicalTechniqueOptions: state.referenceData.surgicalTechniqueOptions,
    getStudyGroups: state.studyGroup.getStudyGroupsStatus,
    studyGroups: state.studyGroup.studyGroups,
    dentalNotifications: state.referenceData.dentalNotifications,
  };
}

function mapDispatch(dispatch) {
  return {
    actions: bindActionCreators(
      { ...patientActions, ...referenceDataActions, ...studyGroupActions },
      dispatch
    ),
  };
}

export default connect(mapState, mapDispatch)(injectIntl(CreateTreatmentModal));
